import { getContext, setContext, type Component } from 'svelte';

export interface RightPanelData<Props extends Record<string, any>> {
	component: Component<Props>;
	props: Props;
}

export class RightPanelContext {
	current: RightPanelData<any> | null = $state(null);

	open<Props extends Record<string, any>>(
		component: Component<Props>,
		props: Props = {} as Props
	) {
		this.current = { component, props };
	}

	close() {
		this.current = null;
	}
}

export const RIGHT_PANEL_CONTEXT_KEY = Symbol('right-panel');

export function getRightPanelContext() {
	return getContext<RightPanelContext>(RIGHT_PANEL_CONTEXT_KEY);
}

export function setRightPanelContext(ctx: RightPanelContext) {
	setContext(RIGHT_PANEL_CONTEXT_KEY, ctx);
	return ctx;
}
